import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import AdjustIcon from '@mui/icons-material/Adjust';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PeopleIcon from '@mui/icons-material/People';
import SchoolIcon from '@mui/icons-material/School';
import WorkIcon from '@mui/icons-material/Work';
import { HiOutlineCurrencyDollar } from 'react-icons/hi';
import { WsSelectObj } from 'wisestep-base';

export const getMonsterCandidateDetails = (candidate) => [
  {
    icon: <LocationOnIcon sx={{ color: '#888A8E', fontSize: '1.27rem' }} />,
    label: `${candidate.candidateData.currentLocation?.city},${candidate.candidateData.currentLocation?.state},${candidate.candidateData.currentLocation?.country},${candidate.candidateData.currentLocation?.zipCode}`,
    tooltip: 'Candidate Location',
  },
  {
    icon: <WorkIcon sx={{ color: '#888A8E', fontSize: '1.27rem' }} />,
    label: `${
      candidate.candidateData.currentEmployer
        ? candidate.candidateData.currentEmployer
        : 'Not Mentioned'
    }`,
    tooltip: 'Current Employer',
  },
  {
    icon: <AdjustIcon sx={{ color: '#888A8E', fontSize: '1.27rem' }} />,
    label: `${candidate.Target.Relocation.__text}`,
    tooltip: 'Relocation Preference',
  },
  {
    icon: <WorkIcon sx={{ color: '#888A8E', fontSize: '1.27rem' }} />,
    label: `Current Job Title: ${
      candidate.candidateData.currentJobTitle
        ? candidate.candidateData.currentJobTitle
        : 'Not Mentioned'
    }`,
    tooltip: 'Current Job Title',
  },
  {
    icon: <AccessTimeFilledIcon sx={{ color: '#888A8E', fontSize: '1.27rem' }} />,
    label: `Preferred Job Title: ${
      candidate.Target.JobTitle ? candidate.Target.JobTitle : 'Not Mentioned'
    }`,
    tooltip: 'Preferred Job Title',
  },
  {
    icon: <LibraryBooksIcon sx={{ color: '#888A8E', fontSize: '1.27rem' }} />,
    label: `${
      candidate.candidateData.workAuthorization
        ? candidate.candidateData.workAuthorization
        : 'Not Mentioned'
    }`,
    tooltip: 'Work Authorization',
  },
  {
    icon: <HiOutlineCurrencyDollar color="#888A8E" size="1.27rem" />,
    label:
      +candidate.Target.Salary.Min != 0 || +candidate.Target.Salary.Max != 0
        ? `${candidate.Target.Salary.Currency.__text} ${candidate.Target.Salary.Min} - ${candidate.Target.Salary.Currency.__text} ${candidate.Target.Salary.Max}`
        : 'Not Mentioned',
    tooltip: 'Desired Salary',
  },
  {
    icon: <SchoolIcon sx={{ color: '#888A8E', fontSize: '1.27rem' }} />,
    label: `${candidate.HighestEducation ? candidate.HighestEducation : 'Not Mentioned'}`,
    tooltip: 'Education',
  },
  {
    icon: <PeopleIcon sx={{ color: '#888A8E', fontSize: '1.27rem' }} />,
    label: `${candidate.candidateData.source}`,
    tooltip: 'Source',
  },
];

export const COUNTRIES = {
  '1': 'Afghanistan',
  '2': 'Albania',
  '3': 'Algeria',
  '178': 'American Samoa',
  '4': 'Andorra',
  '5': 'Angola',
  '176': 'Anguilla',
  '177': 'Antarctica',
  '175': 'Antigua and Barbuda',
  '6': 'Argentina',
  '7': 'Armenia',
  '179': 'Aruba',
  '8': 'Australia',
  '9': 'Austria',
  '10': 'Azerbaidjan',
  '11': 'Bahamas',
  '12': 'Bahrain',
  '13': 'Bangladesh',
  '14': 'Barbados',
  '15': 'Belarus',
  '16': 'Belgium',
  '17': 'Belize',
  '18': 'Benin',
  '19': 'Bermuda',
  '20': 'Bhutan',
  '21': 'Bolivia',
  '22': 'Bosnia-Herzegovina',
  '23': 'Botswana',
  '181': 'Bouvet Island',
  '24': 'Brazil',
  '201': 'British Indian Ocean Territory',
  '180': 'Brunei Darussalam',
  '25': 'Bulgaria',
  '26': 'Burkina Faso',
  '27': 'Burundi',
  '28': 'Cambodia',
  '29': 'Cameroon',
  '30': 'Canada',
  '31': 'Cape Verde',
  '32': 'Cayman Islands',
  '33': 'Central African Republic',
  '34': 'Chad',
  '35': 'Chile',
  '36': 'China',
  '185': 'Christmas Island',
  '182': 'Cocos (Keeling) Islands',
  '37': 'Colombia',
  '204': 'Comoros',
  '38': 'Congo',
  '183': 'Cook Islands',
  '39': 'Costa Rica',
  '40': 'Croatia',
  '184': 'Cuba',
  '41': 'Cyprus',
  '42': 'Czech Republic',
  '43': 'Denmark',
  '44': 'Djibouti',
  '186': 'Dominica',
  '187': 'Dominican Republic',
  '233': 'East Timor',
  '45': 'Ecuador',
  '46': 'Egypt',
  '47': 'El Salvador',
  '48': 'Equatorial Guinea',
  '49': 'Eritrea',
  '50': 'Estonia',
  '51': 'Ethiopia',
  '189': 'Islands',
  '191': 'Faroe Islands',
  '52': 'Fiji',
  '53': 'Finland',
  '228': 'Former USSR',
  '54': 'France',
  '55': 'France (European Territory)',
  '193': 'French Guyana',
  '230': 'French Southern Territories',
  '56': 'Gabon',
  '57': 'Gambia',
  '58': 'Georgia',
  '59': 'Germany',
  '60': 'Ghana',
  '194': 'Gibraltar',
  '61': 'Greece',
  '195': 'Greenland',
  '192': 'Grenada',
  '196': 'Guadeloupe (French)',
  '62': 'Guam',
  '198': 'Guatemala',
  '63': 'Guinea',
  '64': 'Guinea Bissau',
  '65': 'Guyana',
  '200': 'Haiti',
  '199': 'Heard and McDonald Islands',
  '66': 'Honduras',
  '67': 'Hong Kong',
  '68': 'Hungary',
  '69': 'Iceland',
  '70': 'India',
  '71': 'Indonesia',
  '72': 'Iran',
  '73': 'Iraq',
  '74': 'Ireland',
  '75': 'Israel',
  '76': 'Italy',
  '77': 'Ivory Coast',
  '202': 'Jamaica',
  '78': 'Japan',
  '79': 'Jordan',
  '80': 'Kazakhstan',
  '81': 'Kenya',
  '203': 'Kiribati',
  '82': 'Kuwait',
  '83': 'Kyrgyzstan',
  '84': 'Laos',
  '85': 'Latvia',
  '86': 'Lebanon',
  '87': 'Lesotho',
  '88': 'Liberia',
  '89': 'Libya',
  '90': 'Liechtenstein',
  '91': 'Lithuania',
  '92': 'Luxembourg',
  '208': 'Macau',
  '93': 'Macedonia',
  '94': 'Madagascar',
  '95': 'Malawi',
  '96': 'Malaysia',
  '97': 'Maldives',
  '98': 'Mali',
  '99': 'Malta',
  '207': 'Marshall Islands',
  '210': 'Martinique (French)',
  '100': 'Mauritania',
  '212': 'Mauritius',
  '241': 'Mayotte',
  '101': 'Mexico',
  '190': 'Micronesia',
  '102': 'Moldavia',
  '103': 'Monaco',
  '104': 'Mongolia',
  '211': 'Montserrat',
  '105': 'Morocco',
  '106': 'Mozambique',
  '242': 'Myanmar, Union of (Burma)',
  '107': 'Namibia',
  '215': 'Nauru',
  '108': 'Nepal',
  '109': 'Netherlands',
  '110': 'Netherlands Antilles',
  '216': 'Neutral Zone',
  '213': 'New Caledonia (French)',
  '111': 'New Zealand',
  '112': 'Nicaragua',
  '113': 'Niger',
  '114': 'Nigeria',
  '217': 'Niue',
  '214': 'Norfolk Island',
  '115': 'North Korea',
  '209': 'Northern Mariana Islands',
  '116': 'Norway',
  '117': 'Oman',
  '118': 'Pakistan',
  '222': 'Palau',
  '119': 'Panama',
  '219': 'Papua New Guinea',
  '120': 'Paraguay',
  '121': 'Peru',
  '122': 'Philippines',
  '221': 'Pitcairn Island',
  '123': 'Poland',
  '218': 'Polynesia (French)',
  '124': 'Portugal',
  '126': 'Qatar',
  '127': 'Reunion (French)',
  '128': 'Romania',
  '129': 'Russian Federation',
  '130': 'Rwanda',
  '197': 'S. Georgia & S. Sandwich Islands',
  '224': 'Saint Helena',
  '205': 'Saint Kitts & Nevis Anguilla',
  '206': 'Saint Lucia',
  '220': 'Saint Pierre and Miquelon',
  '131': 'Saint Tome and Principe',
  '237': 'Saint Vincent & Grenadines',
  '132': 'Samoa',
  '227': 'San Marino',
  '133': 'Saudi Arabia',
  '134': 'Senegal',
  '135': 'Seychelles',
  '136': 'Sierra Leone',
  '137': 'Singapore',
  '138': 'Slovakia',
  '139': 'Slovenia',
  '223': 'Solomon Islands',
  '140': 'Somalia',
  '141': 'South Africa',
  '142': 'South Korea',
  '143': 'Spain',
  '144': 'Sri Lanka',
  '145': 'Sudan',
  '146': 'Suriname',
  '225': 'Svalbard and Mayen Islands',
  '147': 'Swaziland',
  '148': 'Sweden',
  '149': 'Switzerland',
  '150': 'Syria',
  '151': 'Tadjikistan',
  '152': 'Taiwan',
  '153': 'Tanzania',
  '154': 'Thailand',
  '155': 'Togo',
  '231': 'Tokelau',
  '232': 'Tonga',
  '234': 'Trinidad and Tobago',
  '156': 'Tunisia',
  '157': 'Turkey',
  '158': 'Turkmenistan',
  '229': 'Turks and Caicos Islands',
  '235': 'Tuvalu',
  '159': 'Uganda',
  '160': 'UK',
  '161': 'Ukraine',
  '162': 'United Arab Emirates',
  '163': 'Uruguay',
  '164': 'US',
  '236': 'USA Minor Outlying Islands',
  '165': 'Uzbekistan',
  '239': 'Vanuatu',
  '166': 'Vatican City',
  '167': 'Venezuela',
  '168': 'Vietnam',
  '169': 'Virgin Islands (British)',
  '238': 'Virgin Islands (USA)',
  '240': 'Wallis and Futuna Islands',
  '188': 'Western Sahara',
  '170': 'Yemen',
  '171': 'Yugoslavia',
  '172': 'Zaire',
  '173': 'Zambia',
  '174': 'Zimbabwe',
};

export const languageOptions: WsSelectObj[] = [
  { label: ' Aboriginal Dialects', value: '1' },
  { label: ' Afrikaans', value: '2' },
  { label: ' American Sign Language', value: '3' },
  { label: ' Ancient Greek', value: '4' },
  { label: ' Arabic', value: '5' },
  { label: ' Assamese', value: '6' },
  { label: ' Australian Sign Language', value: '7' },
  { label: ' Bahasa Indonesia', value: '8' },
  { label: ' Basque', value: '9' },
  { label: ' Bengali', value: '10' },
  { label: ' Brazilian Portugese', value: '11' },
  { label: ' Breton', value: '12' },
  { label: ' British Sign Language', value: '13' },
  { label: ' Bulgarian', value: '14' },
  { label: ' Burmese', value: '15' },
  { label: ' Catalan', value: '16' },
  { label: ' Chinese', value: '17' },
  { label: ' Chinese - Cantonese', value: '18' },
  { label: ' Chinese - Mandarin', value: '19' },
  { label: ' Chinese - Taiwanese', value: '20' },
  { label: ' Corsican', value: '21' },
  { label: ' Croatian', value: '22' },
  { label: ' Czech', value: '23' },
  { label: ' Danish', value: '24' },
  { label: ' Dutch', value: '25' },
  { label: ' Egyptian', value: '26' },
  { label: ' English', value: '27' },
  { label: ' Estonian', value: '28' },
  { label: ' Farsi', value: '29' },
  { label: ' Finnish', value: '30' },
  { label: ' Flemmish', value: '31' },
  { label: ' French', value: '32' },
  { label: ' Frisian', value: '33' },
  { label: ' Gaelic', value: '34' },
  { label: ' German', value: '35' },
  { label: ' Greek', value: '36' },
  { label: ' Greenlandic', value: '37' },
  { label: ' Gujarati', value: '38' },
  { label: ' Hebrew', value: '39' },
  { label: ' Hindi', value: '40' },
  { label: ' Hindustan', value: '41' },
  { label: ' Hmong', value: '42' },
  { label: ' Hungarian', value: '43' },
  { label: ' Icelandic', value: '44' },
  { label: ' Irish', value: '45' },
  { label: ' Irish Gaelic', value: '46' },
  { label: ' Italian', value: '47' },
  { label: ' Japanese', value: '48' },
  { label: ' Kannada', value: '49' },
  { label: ' Kashmiri', value: '50' },
  { label: ' Korean', value: '51' },
  { label: ' Kurdish', value: '52' },
  { label: ' Latin', value: '53' },
  { label: ' Latvian', value: '54' },
  { label: ' Lithuanian', value: '55' },
  { label: ' Malay', value: '56' },
  { label: ' Malayalam', value: '57' },
  { label: ' Manipuri', value: '58' },
  { label: ' Manx Gaelic', value: '59' },
  { label: ' Maori', value: '60' },
  { label: ' Marathi', value: '61' },
  { label: ' Nepali', value: '62' },
  { label: ' Norwegian', value: '63' },
  { label: ' Oriya', value: '64' },
  { label: ' Other', value: '65' },
  { label: ' Polish', value: '66' },
  { label: ' Portuguese', value: '67' },
  { label: ' Prakrit', value: '68' },
  { label: ' Punjabi', value: '69' },
  { label: ' Romanian', value: '70' },
  { label: ' Russian', value: '71' },
  { label: ' Sanskrit', value: '72' },
  { label: ' Scots', value: '73' },
  { label: ' Scots Gaelic', value: '74' },
  { label: ' Serbian', value: '75' },
  { label: ' Sicilian', value: '76' },
  { label: ' Slovak', value: '77' },
  { label: ' Slovene', value: '78' },
  { label: ' Spanish', value: '79' },
  { label: ' Swahili', value: '80' },
  { label: ' Swedish', value: '81' },
  { label: ' Tagalog', value: '82' },
  { label: ' Tamil', value: '83' },
  { label: ' Telugu', value: '84' },
  { label: ' Thai', value: '85' },
  { label: ' Tibetan', value: '86' },
  { label: ' Turkish', value: '87' },
  { label: ' Ukrainian', value: '88' },
  { label: ' Urdu', value: '89' },
  { label: ' Vietnamese', value: '90' },
  { label: ' Welsh', value: '91' },
  { label: ' Yiddish', value: '92' },
  { label: ' Ainu', value: '93' },
  { label: ' Akkadian', value: '94' },
  { label: ' Alurian', value: '95' },
  { label: ' Arkian', value: '96' },
  { label: ' Assyrian', value: '97' },
  { label: ' Asturian', value: '98' },
  { label: ' Aymara', value: '99' },
  { label: ' Basque Language-Euskara', value: '100' },
  { label: ' Berber', value: '101' },
  { label: ' Buhi', value: '102' },
  { label: ' Cherokee', value: '103' },
  { label: ' Chichewa', value: '104' },
  { label: ' Church Slavonic', value: '105' },
  { label: ' Cornish', value: '106' },
  { label: ' Dakota', value: '107' },
  { label: ' Degaspregos', value: '108' },
  { label: ' Dilhok', value: '109' },
  { label: ' Dongxiang', value: '110' },
  { label: ' Esperanto', value: '111' },
  { label: ' Eurolang', value: '112' },
  { label: ' Faroese', value: '113' },
  { label: ' Friulian', value: '114' },
  { label: ' Galician', value: '115' },
  { label: ' Georgian', value: '116' },
  { label: ' Guarani', value: '117' },
  { label: ' Haponish', value: '118' },
  { label: ' Hausa', value: '119' },
  { label: ' Hawaiian', value: '120' },
  { label: ' Hawaiian Pidgin English', value: '121' },
  { label: ' Ido', value: '122' },
  { label: ' Ingush', value: '123' },
  { label: ' Jameld', value: '124' },
  { label: ' Kankonian', value: '125' },
  { label: ' Khmer', value: '126' },
  { label: ' Kiswahili', value: '127' },
  { label: ' Konkani', value: '128' },
  { label: ' Ladin', value: '129' },
  { label: ' Ladino', value: '130' },
  { label: ' Lakhota', value: '131' },
  { label: ' Loglan', value: '132' },
  { label: ' Low Saxon', value: '133' },
  { label: ' Malat', value: '134' },
  { label: ' Mongolian', value: '135' },
  { label: ' Neelan', value: '136' },
  { label: ' Novial', value: '137' },
  { label: ' Occitan', value: '138' },
  { label: ' Ojibwe', value: '139' },
  { label: ' Pashto', value: '140' },
  { label: ' Pidgin', value: '141' },
  { label: ' Quechua', value: '142' },
  { label: ' Rhaeto -Romance', value: '143' },
  { label: ' Romany', value: '144' },
  { label: ' Shiyeyi', value: '145' },
  { label: ' Sindhi', value: '146' },
  { label: ' Sinhalese', value: '147' },
  { label: ' Swabian', value: '148' },
  { label: ' Tengwar', value: '149' },
  { label: ' Tok Pisin', value: '150' },
  { label: ' Uzbek', value: '151' },
  { label: ' Vogu', value: '152' },
  { label: ' Xhamagas', value: '153' },
  { label: ' Yoruba', value: '154' },
  { label: ' Albanian', value: '155' },
  { label: ' Luxembourgish', value: '156' },
  { label: ' Sami', value: '157' },
  { label: ' Xhosa', value: '158' },
  { label: ' Zulu', value: '159' },
  { label: ' Bosnian', value: '160' },
  { label: ' Pidgin Signed English', value: '161' },
  { label: ' Signing Exact English', value: '162' },
  { label: ' Tactile Sign Language', value: '163' },
  { label: ' Armenian', value: '164' },
  { label: ' Macedonian', value: '165' },
];

export const languageProficiencyOptions: WsSelectObj[] = [
  { label: ' Unknown.', value: '0' },
  { label: ' Basic - Familiar', value: '1' },
  { label: ' Conversational - Limited', value: '2' },
  { label: ' Conversational', value: '3' },
  { label: ' Conversational - Advanced', value: '4' },
  { label: ' Fluent - Wide Knowledge', value: '5' },
  { label: ' Fluent - Full Knowledge', value: '6' },
];

export const KeyWordQueryOptions: WsSelectObj[] = [
  {
    label: 'Select',
    value: '',
  },
  {
    label: 'And',
    value: 'and',
  },
  {
    label: 'Or',
    value: 'or',
  },
  {
    label: 'Boolean',
    value: 'bool',
  },
];

export const targetJobTypeOptions: WsSelectObj[] = [
  {
    label: 'Any',
    value: '',
  },
  {
    label: 'Permanent',
    value: 'tjtp',
  },
  {
    label: 'Contract',
    value: 'tjttc',
  },
  {
    label: 'Full Time',
    value: 'tjtft',
  },
  {
    label: 'Part Time',
    value: 'tjtpt',
  },
  {
    label: 'Intern',
    value: 'tjti',
  },
  {
    label: 'Per Diem',
    value: 'tjtpd',
  },
  {
    label: 'Seasonal',
    value: 'tjts',
  },
];

export const educationLevelOptions: WsSelectObj[] = [
  {
    label: 'Select',
    value: '',
  },
  {
    label: 'High School or equivalent',
    value: '1',
  },
  {
    label: 'Certification',
    value: '2',
  },
  {
    label: 'Vocational',
    value: '3',
  },
  {
    label: 'Associate Degree',
    value: '4',
  },
  {
    label: 'Bachelors Degree',
    value: '5',
  },
  {
    label: 'Masters Degree',
    value: '6',
  },
  {
    label: 'Doctorate',
    value: '7',
  },
  {
    label: 'Professional',
    value: '8',
  },
  {
    label: 'Some College Coursework Completed',
    value: '9',
  },
  {
    label: 'Vocational – High School',
    value: '10',
  },
  {
    label: 'Vocational – Degree',
    value: '11',
  },
];

export const WillingRelocateOptions: WsSelectObj[] = [
  {
    label: 'Select',
    value: '',
  },
  {
    label: 'Yes',
    value: '1',
  },
  {
    label: 'No',
    value: '0',
  },
];

export const workSiteOptions: WsSelectObj[] = [
  {
    label: 'Select',
    value: '',
  },
  {
    label: 'On Site',
    value: '1',
  },
  {
    label: 'Off Site',
    value: '2',
  },
  {
    label: 'No Preference',
    value: '3',
  },
];

export const workAuthorizationOptions: WsSelectObj[] = [
  {
    label: 'Select',
    value: '',
  },
  {
    label: 'Authorized to work for any employer',
    value: '1',
  },
  {
    label: 'Authorized to work for current employer only',
    value: '2',
  },
  {
    label: 'Require sponsorship',
    value: '3',
  },
];

export const desiredSalaryOptions: WsSelectObj[] = [
  { label: 'Argentina Peso', value: '3' },
  { label: 'Australia Dollar', value: '4' },
  { label: 'Belgium Franc', value: '5' },
  { label: 'Brazil Real', value: '6' },
  { label: 'Canada Dollar', value: '7' },
  { label: 'China Yuan Renmimbi', value: '9' },
  { label: 'Czech Republic Koruna', value: '10' },
  { label: 'Danish Krone', value: '38' },
  { label: 'Euro', value: '2' },
  { label: 'Fiji Dollar', value: '13' },
  { label: 'Finnish Mark', value: '39' },
  { label: 'France Franc', value: '14' },
  { label: 'Germany Deutsche Mark', value: '11' },
  { label: 'Greece Drachma', value: '16' },
  { label: 'Hong Kong Dollar', value: '17' },
  { label: 'Hungary Forint', value: '18' },
  { label: 'India Rupee', value: '22' },
  { label: 'Indonesia Rupiah', value: '19' },
  { label: 'Ireland Punt', value: '20' },
  { label: 'Israel New Shekel', value: '21' },
  { label: 'Italy Lira', value: '23' },
  { label: 'Japan Yen', value: '24' },
  { label: 'Luxemborg Franc', value: '36' },
  { label: 'Malaysia Ringgit', value: '27' },
  { label: 'Mexico Peso', value: '26' },
  { label: 'Netherlands Guilder', value: '28' },
  { label: 'New Zealand Dollar', value: '29' },
  { label: 'Norwegian Krone', value: '37' },
  { label: 'Poland Zloty', value: '30' },
  { label: 'Russia Ruble', value: '31' },
  { label: 'Singapore Dollar', value: '33' },
  { label: 'South Africa Rand', value: '35' },
  { label: 'South Korea Won', value: '25' },
  { label: 'Spain Peseta', value: '12' },
  { label: 'Sweden Krona', value: '32' },
  { label: 'Switzerland Franc', value: '8' },
  { label: 'Taiwan Dollar', value: '34' },
  { label: 'United Kingdom Pound', value: '15' },
  { label: 'US Dollar', value: '1' },
];

export const desiredSalaryTimeSpanOptions: WsSelectObj[] = [
  { label: 'Yearly', value: '1' },
  { label: 'Hourly', value: '2' },
  { label: 'Weekly', value: '3' },
  { label: 'Monthly', value: '4' },
];

export const managerialExperienceOptions: WsSelectObj[] = [
  {
    label: 'Select',
    value: '',
  },
  {
    label: 'No',
    value: '1',
  },
  {
    label: 'Yes',
    value: '2',
  },
];

export const yearExperienceOptions: WsSelectObj[] = [
  {
    label: 'Select',
    value: '',
  },
  {
    label: 'Less than 1 Year',
    value: '1',
  },
  {
    label: '1+ to 2 Years',
    value: '2',
  },
  {
    label: '2+ to 5 Years',
    value: '3',
  },
  {
    label: '5+ to 7 Years',
    value: '4',
  },
  {
    label: '7+ to 10 Years',
    value: '5',
  },
  {
    label: '10+ to 15 Years',
    value: '6',
  },
  {
    label: 'more than 15 Years',
    value: '7',
  },
];

export const targetWorkIndustriesOptions: WsSelectObj[] = [
  { label: 'All', value: '0' },
  { label: 'Agriculture/Forestry/Fishing', value: '1' },
  { label: 'Metals and Minerals', value: '2' },
  { label: 'Energy and Utilities', value: '3' },
  {
    label: 'Construction - Industrial Facilities and Infrastructure',
    value: '4',
  },
  { label: 'Trade Contractors', value: '5' },
  { label: 'Aerospace and Defense', value: '6' },
  { label: 'Automotive and Parts Mfg', value: '7' },
  { label: 'Biotechnology/Pharmaceuticals', value: '8' },
  { label: 'Chemicals/Petro-Chemicals', value: '9' },
  { label: 'Consumer Packaged Goods Manufacturing', value: '10' },
  { label: 'Electronics, Components, and Semiconductor Mfg', value: '11' },
  { label: 'Manufacturing - Other', value: '12' },
  { label: 'Printing and Publishing', value: '13' },
  { label: 'Clothing and Textile Manufacturing', value: '14' },
  { label: 'Wholesale Trade/Import-Export', value: '15' },
  { label: 'Grocery/Convenience/Gas', value: '16' },
  { label: 'Retail', value: '17' },
  { label: 'Travel, Transportation and Tourism', value: '18' },
  { label: 'Transport and Storage - Materials', value: '19' },
  { label: 'Internet Services', value: '20' },
  { label: 'Broadcasting, Music, and Film', value: '21' },
  { label: 'Telecommunications Services', value: '22' },
  { label: 'Banking', value: '23' },
  { label: 'Insurance', value: '24' },
  { label: 'Mortgage', value: '25' },
  { label: 'Real Estate/Property Management', value: '26' },
  { label: 'Rental Services', value: '27' },
  { label: 'Accounting and Auditing Services', value: '28' },
  { label: 'Advertising and PR Services', value: '29' },
  { label: 'Architectural and Design Services', value: '30' },
  { label: 'Management Consulting Services', value: '31' },
  { label: 'Computer Hardware', value: '32' },
  { label: 'Computer Software', value: '33' },
  { label: 'Legal Services', value: '34' },
  { label: 'Management and Holding Companies', value: '35' },
  { label: 'Administrative and Support Services', value: '36' },
  { label: 'Waste Management', value: '37' },
  { label: 'Education', value: '38' },
  { label: 'Healthcare Services', value: '39' },
  { label: 'Nursing/Residential Care Facilities', value: '40' },
  { label: 'Social Services', value: '41' },
  { label: 'Performing and Fine Arts', value: '42' },
  { label: 'Sports and Physical Recreation', value: '43' },
  { label: 'Hotels and Lodging', value: '44' },
  { label: 'Restaurant/Food Services', value: '45' },
  { label: 'Staffing/Employment Agencies', value: '46' },
  { label: 'Nonprofit Charitable Organizations', value: '47' },
  { label: 'Personal and Household Services', value: '48' },
  { label: 'Repair and Maintenance Services', value: '49' },
  { label: 'Government and Military', value: '50' },
  { label: 'Government- Military/Defense', value: '51' },
  { label: 'Government- National', value: '52' },
  { label: 'Security and Surveillance', value: '74' },
  { label: 'Automotive Sales and Repair Services', value: '75' },
  { label: 'Business Services - Other', value: '76' },
  { label: 'Computer/IT Services', value: '77' },
  { label: 'Construction - Residential & Commercial/Office', value: '78' },
  { label: 'Engineering Services', value: '79' },
  { label: 'Entertainment Venues and Theaters', value: '80' },
  { label: 'Financial Services', value: '81' },
  { label: 'Food and Beverage Production', value: '82' },
  { label: 'Marine Mfg & Services', value: '83' },
  { label: 'Medical Devices and Supplies', value: '84' },
  { label: 'Other/Not Classified', value: '85' },
];

export const careerLevelCheckBoxOptions = {
  '10': 'Student (Undergraduate/Graduate)',
  '11': 'Entry Level',
  '12': 'Experienced (Non-Manager)',
  '13': 'Manager (Manager/Supervisor of Staff)',
  '14': 'Executive (SVP, VP, Department Head, etc)',
  '15': 'Senior Executive (President, CFO, etc)',
  '16': 'Student (High School)',
};

export const globalLevelSecurityCheckBoxOptions = {
  '11': 'None',
  '12': 'Active Confidential',
  '13': 'Active Secret',
  '14': 'Active Top Secret',
  '15': 'Inactive Confidential',
  '16': 'Inactive Secret',
  '17': 'Inactive Top Secret',
};

export const globalMilitaryCheckBoxOptions = {
  '0': 'None',
  '1': 'Unspecified',
  '2': 'Active Duty',
  '3': 'Retired Military',
  '4': 'Veteran/Prior Service',
  '5': 'Reservist (drilling)',
  '6': 'National Guard',
  '7': 'Inactive Reserve/Guard (not drilling)',
  '8': 'Service Academy',
  '9': 'In Military Preparation',
  '10': 'Other Military Program',
  '11': 'Government Employee',
  '12': 'Defense Contractor',
  '13': 'Considering Joining',
  '14': 'Military Spouse',
  '15': 'Spouse of a Veteran',
  '16': 'Other Military Family Member',
};

export const powerTargetJobTypeOptions: WsSelectObj[] = [
  {
    label: 'Any',
    value: '',
  },
  {
    label: 'Full Time',
    value: '1',
  },
  {
    label: 'Part Time',
    value: '2',
  },
  {
    label: 'Intern',
    value: '3',
  },
  {
    label: 'Temp/Contract/Seasonal',
    value: '4',
  },
];

export const powerMinimumEducationLevelOptions: WsSelectObj[] = [
  {
    label: 'Select',
    value: '',
  },
  {
    label: 'High School or equivalent',
    value: '1',
  },
  {
    label: 'Certification',
    value: '2',
  },
  {
    label: 'Vocational',
    value: '3',
  },
  {
    label: 'Associate Degree',
    value: '4',
  },
  {
    label: 'Bachelors Degree',
    value: '5',
  },
  {
    label: 'Masters Degree',
    value: '6',
  },
  {
    label: 'Doctorate',
    value: '7',
  },
  {
    label: 'Professional',
    value: '8',
  },
  {
    label: 'Some College Coursework Completed',
    value: '9',
  },
  {
    label: 'Some High School Coursework',
    value: '12',
  },
];

export const powerRelocationOptions: WsSelectObj[] = [
  {
    label: 'Select',
    value: '',
  },
  {
    label: 'Yes',
    value: 'true',
  },
  {
    label: 'No',
    value: 'false',
  },
];

export const powerWillingTravelOptions: WsSelectObj[] = [
  {
    label: 'Select',
    value: '',
  },
  {
    label: 'No willing to travel',
    value: '1',
  },
  {
    label: '25% willing to travel',
    value: '2',
  },
  {
    label: '50% willing to travel',
    value: '3',
  },
  {
    label: '75% willing to travel',
    value: '4',
  },
  {
    label: '100% willing to travel',
    value: '5',
  },
];
export const powerCitizenShipCheckBoxOptions = {
  '1': 'US Citizen',
  '2': 'Permanent Resident',
  '3': 'Other',
};

export const powerWorkAuthorizationOptions: WsSelectObj[] = [
  {
    label: 'Select',
    value: '',
  },
  {
    label: 'Authorized to work for any employer',
    value: '1',
  },
  {
    label: 'Authorized to work for current employer only',
    value: '2',
  },
  {
    label: 'Require sponsorship',
    value: '3',
  },
];

export const powerCareerLevelOptions: WsSelectObj[] = [
  {
    label: 'Select',
    value: '',
  },
  {
    label: 'President',
    value: '1',
  },
  {
    label: 'Executive Level',
    value: '2',
  },
  {
    label: 'General Manager',
    value: '3',
  },
  {
    label: 'Vice President',
    value: '4',
  },
  {
    label: 'Director',
    value: '5',
  },
  {
    label: 'Head',
    value: '6',
  },
  {
    label: 'Manager',
    value: '7',
  },
  {
    label: 'Lead',
    value: '8',
  },
  {
    label: 'Other',
    value: '9',
  },
  {
    label: 'Analyst',
    value: '10',
  },
  {
    label: 'Representative',
    value: '11',
  },
  {
    label: 'Specialist',
    value: '12',
  },
  {
    label: 'Clerk',
    value: '13',
  },
  {
    label: 'Coordinator',
    value: '14',
  },
  {
    label: 'Assistant',
    value: '15',
  },
];

export const powerYearlySalaryOptions: WsSelectObj[] = [
  {
    label: 'Select',
    value: '',
  },
  {
    label: '$30,000',
    value: '30000-USD',
  },
  {
    label: '$40,000',
    value: '40000-USD',
  },
  {
    label: '$50,000',
    value: '50000-USD',
  },
  {
    label: '$60,000',
    value: '60000-USD',
  },
  {
    label: '$70,000',
    value: '70000-USD',
  },
  {
    label: '$80,000',
    value: '80000-USD',
  },
  {
    label: '$90,000',
    value: '90000-USD',
  },
  {
    label: '$100,000',
    value: '100000-USD',
  },
  {
    label: '$125,000',
    value: '125000-USD',
  },
  {
    label: '$150,000',
    value: '150000-USD',
  },
];

export const powerGlobalSecurityCheckBoxOptions = {
  '2': 'Unspecified',
  '3': 'Active Confidential',
  '4': 'Active Secret',
  '5': 'Active Top Secret',
  '6': 'Active Top Secret/SCI',
  '19': 'Active TS/SCI-CI Polygraph	',
  '20': 'Active TS/SCI-FS Polygraph	',
  '21': 'Other Active Clearance	',
};
